var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TableCell as MuiTableCell } from '@mui/material';
import Text from '../../Text';
import getCellAlignment from './getCellAlignment';
export function renderFooterCell(args) {
    var data = args.data, columnIndex = args.index, config = args.config, columnConfig = args.column;
    if (!(config === null || config === void 0 ? void 0 : config.footerRenderer))
        return null;
    var allColumnData = data.map(function (row) { return row[columnConfig.key]; });
    var cellProps = {
        index: columnIndex,
        header: columnConfig.key,
        columnData: allColumnData,
        data: data
    };
    var content = config.footerRenderer(cellProps);
    if (typeof content === 'string') {
        content = (_jsx(Text, __assign({ ellipsis: true, variant: "table1" }, { children: content })));
    }
    var style = {
        position: 'sticky',
        bottom: 0,
        zIndex: 2
    };
    var alignment = getCellAlignment({
        cellArgs: {
            isHovering: false,
            rowIndex: data.length,
            row: undefined,
            index: columnIndex,
            cell: allColumnData,
            header: columnConfig.key
        },
        config: columnConfig
    });
    if (columnConfig.width)
        style.width = columnConfig.width;
    return (_jsx(MuiTableCell, __assign({ sx: style, align: alignment }, { children: content }), "".concat(columnConfig.key, "_footer_").concat(columnIndex)));
}
